import * as React from "react";
import { SVGProps } from "react";
export const EnvelopeOpenFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.41699 17.5C2.93099 17.5 2.51766 17.33 2.17699 16.99C1.83699 16.6493 1.66699 16.236 1.66699 15.75V6.833C1.66699 6.51367 1.73633 6.21867 1.87499 5.948C2.01366 5.67733 2.22199 5.45867 2.49999 5.292L9.10399 1.354C9.24266 1.27067 9.38866 1.21167 9.54199 1.177C9.69466 1.14233 9.84733 1.125 9.99999 1.125C10.1527 1.125 10.3053 1.14233 10.458 1.177C10.6113 1.21167 10.7573 1.27067 10.896 1.354L17.521 5.292C17.785 5.45867 17.9863 5.67733 18.125 5.948C18.2637 6.21867 18.333 6.51367 18.333 6.833V15.75C18.333 16.236 18.163 16.6493 17.823 16.99C17.4823 17.33 17.069 17.5 16.583 17.5H3.41699ZM9.99999 10.396C10.0693 10.396 10.1457 10.3857 10.229 10.365C10.3123 10.3437 10.3887 10.3123 10.458 10.271L16.438 6.708L10.458 3.146C10.3887 3.104 10.3123 3.07267 10.229 3.052C10.1457 3.03133 10.0693 3.021 9.99999 3.021C9.93066 3.021 9.85433 3.03133 9.77099 3.052C9.68766 3.07267 9.61133 3.104 9.54199 3.146L3.58299 6.708L9.54199 10.271C9.61133 10.3123 9.68766 10.3437 9.77099 10.365C9.85433 10.3857 9.93066 10.396 9.99999 10.396Z"
            fill="currentColor"
        />
    </svg>
);
EnvelopeOpenFillIcon.displayName = "EnvelopeOpenFillIcon";
